import { useEffect, useState } from "react";
import styles from "./index.module.scss";
import Button from "../../../common/button";
import { safeLocalStorage } from "../../../../utils/safeStorage";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = safeLocalStorage.getItem("cookieAccepted");
    if (!accepted) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    safeLocalStorage.setItem("cookieAccepted", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.Body}>
      <h2 className={styles.Title}>
        Используем куки и рекомендательные технологии
      </h2>
      <span>
        Нажимая «OK», вы соглашаетесь на использование файлов cookie и аналитику
        Яндекс. Метрики для улучшения работы сайта. Вы можете отключить сбор
        cookie в настройках своего браузера.{" "}
        <a href="/privacy/" target="_blank" rel="noreferrer">
          Политика обработки персональных данных.
        </a>
      </span>
      <Button onClick={handleAccept} label={"ОК"}></Button>
    </div>
  );
}
